import { Alert, Button, Form, FormFeedback, FormGroup, Input, Label,Spinner } from 'reactstrap';
import styles from './RegisterPage.module.scss';
import { Link } from 'react-router-dom';
import { useState, useRef, useEffect, useContext } from 'react';
import { useOnChangeHandler } from '../../global/utils/hooks/useOnChangeHandler';
import { useToggle } from '../../global/utils/hooks/useToggle';
import { postRequest } from '../../global/utils/apiCall';
import { AppContext } from '../../global/globalContext/context';
import SEO from '../../global/Components/SEO/SEO';

const EMAIL_REGEX  = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
const USERNAME_REGEX = /^(?=.{3,20}$)(?![_.-])(?!.*[_.-]{2})[a-zA-Z0-9._-]+([^._-])$/;
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@*#$%]).{8,32}$/;

export default function Register() {
  const usernameRef = useRef();
  const errorRef = useRef();
  const REGISTER_URL= 'api/v1/user/signup';
  const { setting } = useContext(AppContext);
  
  const [username, setUsername, onChangeHandlerUsername] = useOnChangeHandler('');
  const [validUserName, setValidUserName] = useState(false);
  
  const [email, setEmail, onChangeHandlerEmail] = useOnChangeHandler('');
  const [validEmail, setValidEmail] = useState(false);
  
  const [password, setPassword, onChangePassword] = useOnChangeHandler('');
  const [validPassword, setValidPassword] = useState(false);
  
  const [confirmPassword, setConfirmPassword, onChangeHandlerConfirmPassword] = useOnChangeHandler('');
  const [validConfirmPassword, setValidConfirmPassword] = useState(false);
  
  const [isShowPassword, setIsShoPassword, toggleIsShowPassword] = useToggle(false);

  const [ errorMsg, setErrorMsg] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    usernameRef.current.focus();
  }, []);

  useEffect(() => {
    setValidEmail(EMAIL_REGEX.test(email));
  },[email]);

  useEffect(() => {
    setValidUserName(USERNAME_REGEX.test(username));
  },[username]);

  useEffect(() => {
    setValidPassword(PASSWORD_REGEX.test(password));
    setValidConfirmPassword(password === confirmPassword)
  },[password,confirmPassword]);

  useEffect(() => {
    setErrorMsg('');
  },[username,password,confirmPassword]);

  const handleSubmit = async (e) => {   
    e.preventDefault();

    setIsLoading(true);
    //if button enable with js hack
    const vUsername = USERNAME_REGEX.test(username);
    const vPassword = PASSWORD_REGEX.test(password);
    
    if (!vUsername || !vPassword) {
      setErrorMsg("Invalid Entry");
      return;
    } 
    try
      {
        const response = await postRequest(REGISTER_URL,JSON.stringify({ username, email, password, password_confirmation: confirmPassword}));
        if (response) {
          setUsername('');
          setEmail('');
          setPassword('');
          setConfirmPassword('');
          setSuccess(true);
          setIsLoading(false);
        }
      }
    catch(error)
      {
        setIsLoading(false);
        if (!error?.response) {
          setErrorMsg('No Server Response');
        } else if (error.response?.status === 409) {
            setErrorMsg('Username Taken');
        } else if (error.response.status == 400){
            setErrorMsg('Bad Request');
        } else if (error.response.status == 404){
            setErrorMsg('Not found');
        } else
        {
            setErrorMsg('Registration Failed')
        }
        errorRef.current.focus();
      }
      finally {
        setIsLoading(false);
      }
  }

  return (
    <>
      <SEO title={'Register'} />
      {
        success ? (
          <div className={`d-flex align-items-center justify-content-center ${styles.loginContainer}`}>
            <div className={`${styles.login} lgtBackground bg-white p-4`}>
              congratulations, you registered!
              Please check your email and verify your account
            </div>
          </div>
        ) : (
          <div className={`d-flex align-items-center justify-content-center ${styles.loginContainer}`}>
            <div className={`${styles.login} lgtBackground bg-white p-4`}>
              <Alert aria-live="assertive"
                  color='danger'
                  innerRef={errorRef}
                  className={errorMsg ? `` : `d-none`}
                  >
                    {errorMsg}
              </Alert>
              <Link to='/' className=''>
                {
                setting
                  ? <img src={`${`${process.env.REACT_APP_API_URL}${setting.logo
                  }`}`} alt="letgo or trade logo" width={'120px'} className={`my-3`}/>
                  : ''
                }
              </Link>
              <div className='fw-bold mb-3'>Register</div>
              <Form className='mb-3'
                    onSubmit={handleSubmit}>
                <FormGroup floating>
                  <Input 
                    id ="username"
                    value ={username}
                    placeholder ='Username'
                    type ='text'
                    innerRef = {usernameRef}
                    autoComplete ='off'
                    required
                    onChange = {onChangeHandlerUsername}
                    valid = { validUserName && true }
                    invalid = { username && !validUserName ? true :false }
                    />
                    <FormFeedback tooltip>
                      3 to 20 characters.<br />
                      Allowed special characters: <span>-</span> <span>.</span> <span>_</span>
                    </FormFeedback>
                  <Label>
                    Username
                  </Label>
                </FormGroup>
                <FormGroup floating>
                  <Input 
                    id ="email"
                    value ={email}
                    placeholder ='Email'
                    type ='email'
                    required
                    onChange ={onChangeHandlerEmail}
                    valid = { validEmail ? true : false }
                    invalid = { email && !validEmail ? true :false }
                    />
                    <FormFeedback tooltip>
                      Recipient name.<br />
                      @ symbol.<br />
                      Domain name.<br />
                      Top-level domain.
                    </FormFeedback>
                  <Label>
                    Email
                  </Label>
                </FormGroup>
                <FormGroup floating>
                  <Input 
                    id ="password"
                    className={`${styles.showPassword} validCheck`}
                    value ={password}
                    placeholder ='Password'
                    type = { !isShowPassword ? "password" : "text"}
                    required
                    onChange ={onChangePassword}
                    valid = { password.length > 0 && validPassword ? true : false}
                    invalid = { password && !validPassword ? true :false }
                    />
                    <span className={`${styles.showIcon}`}
                          onClick={toggleIsShowPassword}
                          >
                      <i className={`bi ${!isShowPassword ? "bi-eye" : "bi-eye-slash"}`}></i>
                    </span>
                    <FormFeedback tooltip>
                        8 to 32 characters.<br />
                        Must include uppercase and lowercase letters, a number and a special character.<br />
                        Allowed special characters: <span aria-label="exclamation mark">!</span> <span aria-label="at symbol">@</span> 
                        <span aria-label="hashtag"> #</span> <span aria-label="dollar sign">$</span> <span aria-label="percent">%</span> <span aria-label="star sign">*</span>
                    </FormFeedback>
                  <Label>
                    Password
                  </Label>
                </FormGroup>
                <FormGroup floating className='position-relative'>
                  <Input 
                    id ="confirmPassword"
                    value ={confirmPassword}
                    placeholder ='Confirm Password'
                    type = { !isShowPassword ? "password" : "text"}
                    required
                    onChange ={onChangeHandlerConfirmPassword}
                    valid = { confirmPassword.length > 0 && validConfirmPassword ? true : false }
                    invalid = { confirmPassword && !validConfirmPassword ? true :false }
                    />
                    <FormFeedback tooltip>
                      Must match the first password input field.
                    </FormFeedback>
                  <Label>
                    Confirm Password
                  </Label>
                </FormGroup>
                <Button 
                  id='register-btn'
                  disabled={ !validUserName || !validEmail || !validPassword || !validConfirmPassword ? true : false }
                  block
                  className={`general-button fw-semibold largBtn`}
                  
                  >
                  {
                    isLoading 
                      ? (
                        <>
                          <Spinner size="sm">
                            Loading...
                          </Spinner>
                          <span>
                            {' '}Loading
                          </span>
                        </>
                      )
                      : 'Register'
                  }
                  
                </Button>
              </Form>
              <div className={`fw-semibold text-center`}>
                <span>Already registered? </span>
                <Link to='/login' className='text-decoration-none'>Login</Link>
              </div>
            </div>
          </div>
        )
      }
    </>
  )
}
